import React from 'react';
import ReactExport from 'react-export-excel';
import Button from '../../../../components/Button';
import { DashboardChartBox, HeaderTitle } from '../styles';

interface RespondentTimingData {
  resultId: number;
  totalTimeMs: number;
  pageCount: number;
}

interface TimePerRespondentTableProps {
  respondentTimingData: RespondentTimingData[];
  formatTime: (ms: number) => string;
}

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;

const TimePerRespondentTable: React.FC<TimePerRespondentTableProps> = ({
  respondentTimingData,
  formatTime,
}) => {
  const preview = respondentTimingData.slice(0, 20);
  return (
    <DashboardChartBox>
      <HeaderTitle>
        <p>Time Per Respondent</p>
      </HeaderTitle>
      <div style={{ marginBottom: 16 }}>
        <ExcelFile
          element={
            <Button $marginRight="16px" $width="200px" $height="36px">
              Export all data to Excel
            </Button>
          }
          filename={`TimePerRespondent-${new Date().toISOString()}`}
        >
          <ExcelSheet data={respondentTimingData} name="TimePerRespondent">
            <ExcelColumn label="Respondent ID" value="resultId" />
            <ExcelColumn label="Total Time Spent (ms)" value="totalTimeMs" />
            <ExcelColumn label="Pages Completed" value="pageCount" />
          </ExcelSheet>
        </ExcelFile>
      </div>
      <h4 style={{ marginBottom: '16px' }}>Preview List (20 records max): </h4>
      <table className="styled-table">
        <thead>
          <tr>
            <th>Respondent ID</th>
            <th>Total Time Spent</th>
            <th>Pages Completed</th>
          </tr>
        </thead>
        <tbody>
          {preview.map(item => (
            <tr key={item.resultId}>
              <td>{item.resultId}</td>
              <td>{formatTime(item.totalTimeMs)}</td>
              <td>{item.pageCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </DashboardChartBox>
  );
};
export default TimePerRespondentTable;
